import { AxiosResponse } from "axios";
import { useEffect } from "react";
import { useContext,useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import { getApiDataWithToken } from "views/utils/CallApi";
import { CtxAuth } from "views/utils/Contexts";
import * as mb from "views/common/MessageBox";
import { pageNoCurrent, pageMaxCurrent, allPage, pageSend, selectPage} from "views/utils/PagingFunc"

interface IFCategoryHistory {
    categoryId: number,
    categoryName: string,
    categorySortNo: number,
    pageNo: number
}
interface IFQuantity {
    pages: number
}

export function CategoryList(): JSX.Element{

    const cua = useContext(CtxAuth);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [pageQuantity, setPageQuantity] = useState<IFQuantity[]>();
    const [maxPage, setMaxPage] = useState<number>(0);
    const [categoryHistory, setCategoryHistory] = useState<IFCategoryHistory[]>();

    useEffect(function(){       
        
        const ctHistory:IFCategoryHistory[] = [];
        const qHistory:IFQuantity[] = [];

        getApiDataWithToken('/management/categories',
            {},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        for (let index = 0; index < res.data.category_list.length; index++) {
                            ctHistory.push({categoryId:res.data.category_list[index].category_id,
                                            categoryName:res.data.category_list[index].category_name,
                                            categorySortNo:res.data.category_list[index].category_sort_no,
                                            pageNo:res.data.category_list[index].page_no});
                        }
                        const array = allPage(res.data.page_max_no)
                        for (let index = 0; index < res.data.page_max_no; index++) {
                            qHistory.push({
                                pages:array[index]
                            })
                        }
                        var url = window.location.href
                        var pageOrder = []
                        if (url.match(/pageNo=/)) {
                            var pageNoStart = url.indexOf('pageNo=')
                            var pageNoEnd = url.indexOf('maxPage=')
                            var result = Number(url.substring((pageNoStart + 7), (pageNoEnd - 1)))
                            pageOrder = ctHistory.filter(item => item.pageNo === result)
                        } else {
                            pageOrder = ctHistory.filter(item => item.pageNo === 1)
                        }
                        setCategoryHistory(pageOrder);
                        setPageQuantity(qHistory);
                        setMaxPage(res.data.page_max_no);
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
            }
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    return (
        <AdminFrame>
            <div className="contents">
                <mb.MessageBox args={msgArgs}/> 
                <h2 className="settings-title-h2">カテゴリー管理</h2>
                <button className="btn-secondary" onClick={function(){window.location.href='edit'}}>新規登録</button>
                <table className="tbl margin-tb-20">
                    <thead>
                        <tr>
                        <th style={{minWidth: "200px"}}>名前</th>
                        <th style={{width: "100px"}} className="text-num">表示順</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categoryHistory?.map(function(val, idx){
                            return(
                                <tr key={idx}>
                                    <td><a href={process.env.PUBLIC_URL + '/admin/category/edit?categoryId=' + val.categoryId}>{val.categoryName}</a></td>
                                    <td className="text-num">{val.categorySortNo}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                <div>
                    <ul className="pagenation">
                        { pageNoCurrent() > 1 ? <li><a href={"?pageNo=" + pageSend(0) + "&maxPage=" + maxPage}>＜</a></li>:<li><a href="/#" onClick={e => e.preventDefault()}>＜</a></li>}
                            {pageQuantity?.map(function(val, idx){
                                return(
                                    <li key={idx}>
                                        <ul>
                                        {selectPage(val.pages) 
                                        ? <li className="is-current">{val.pages}</li>
                                        : <a href={"?pageNo=" + val.pages + "&maxPage=" + maxPage}>{val.pages}</a>
                                        }
                                        </ul>
                                    </li>
                                )
                            })}
                        { pageMaxCurrent(maxPage) ? <li><a href={"?pageNo=" + pageSend(1) + "&maxPage=" + maxPage}>＞</a></li>:<li><a href="/#" onClick={e => e.preventDefault()}>＞</a></li>}
                    </ul>
                </div>
            </div>
        </AdminFrame>
    )
}